import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

const blacklistService = {
  async addToBlacklist(data) {
    try {
      const response = await axios.post(
        `${API_URL}blacklist/add`,
        data,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Ошибка при добавлении в черный список' };
    }
  },

  async searchBlacklist(lastName, firstName = '', middleName = '') {
    try {
      const params = new URLSearchParams();
      params.append('lastName', lastName);
      if (firstName) params.append('firstName', firstName);
      if (middleName) params.append('middleName', middleName);

      const response = await axios.get(
        `${API_URL}blacklist/search?${params.toString()}`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Ошибка при поиске в черном списке' };
    }
  },

  async updateBlacklistEntry(id, data) {
    try {
      const response = await axios.put(
        `${API_URL}blacklist/update/${id}`,
        data,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Ошибка при обновлении записи' };
    }
  },

  async getSearchHistory(limit = 10) {
    try {
      const response = await axios.get(
        `${API_URL}blacklist/history?limit=${limit}`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Ошибка при получении истории' };
    }
  },

  async clearSearchHistory() {
    try {
      const response = await axios.delete(
        `${API_URL}blacklist/history`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Ошибка при очистке истории' };
    }
  }
};

export default blacklistService;
